import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu\"><defs><style></style></defs><path d=\"M63.976 127.976v127.909H959.43v-127.91H63.976zM319.82 575.703h639.61V447.788H319.82v127.915zm0 319.78h639.61V767.541H319.82v127.942zM63.976 575.703H191.9V447.788H63.976v127.915zm0 319.78H191.9V767.541H63.976v127.942z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol